export const isFocusElement = (elem: Element | null): boolean => {
  if (elem === null) {
    return false;
  }

  return elem === document.activeElement;
};

export enum KeyCodes {
  Enter = "Enter",
  Space = "Space",
  ArrowUp = "ArrowUp",
  ArrowDown = "ArrowDown",
  Escape = "Escape",
  Tab = "Tab",
}
